// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YuqueFilledSvg from "@ant-design/icons-svg/es/asn/YuqueFilled";
import AntdIcon from '../components/AntdIcon';

var YuqueFilled = function YuqueFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: YuqueFilledSvg
  }));
};

YuqueFilled.displayName = 'YuqueFilled';
export default React.forwardRef(YuqueFilled);